module.exports = __webpack_public_path__ + "img/947923645.8ca3fbd8.svg";